export const RECEIVE_IS_AUTHENTICATED_DATA =
  'USER/RECEIVE_IS_AUTHENTICATED_DATA';
export const RECEIVE_USER_CONTEXT_DATA = 'RECEIVE_USER_CONTEXT_DATA';
export const RECEIVE_EXTENDED_USER_CONTEXT_DATA =
  'RECEIVE_EXTENDED_USER_CONTEXT_DATA';
